import { EntityRequestExpenses } from "../../entity/EntityRequestExpenses";

export class DtoRequestExpensessDeleteRes extends EntityRequestExpenses {
  public message: string | null = null;
}
